// removed by extract-text-webpack-plugin
module.exports = {"accordion":"style__accordion___2bE1Q","booking_accordion":"style__booking_accordion___1nSRt","event-accordion":"style__event-accordion___2PRgY"};


//////////////////
// WEBPACK FOOTER
// ./components/Accordion/style.scss
// module id = 1202
// module chunks = 0